var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "content-slider-wrapper slider-wrapper" }, [
    _c(
      "div",
      { ref: "carousel", staticClass: "carousel" },
      _vm._l(_vm.slidesData, function (tripData, idx) {
        return _c(
          "div",
          {
            key: idx,
            staticClass: "carousel__slide slider-inner-wrapper",
            attrs: { index: idx },
          },
          [
            _c(
              "div",
              { staticClass: "slider-image" },
              [
                tripData.overrides && tripData.overrides.imagePath
                  ? _c("responsive-concrete-image", {
                      staticClass: "slider-image-inner",
                      attrs: {
                        src: tripData.overrides.imagePath,
                        "available-thumbnails": JSON.parse(
                          tripData.overrides.imagePaths
                        ),
                        "img-class": "img-responsive image-pos-mitte",
                        "aspect-ratio": "16/9",
                        lazyload: false,
                      },
                    })
                  : tripData.bilder
                  ? _c("responsive-image", {
                      staticClass: "slider-image-inner",
                      attrs: {
                        src: tripData.bilder.jpg_fallback_16x9,
                        "src-xs": tripData.bilder.img800_16x9,
                        "src-sm": tripData.bilder.img1000_16x9,
                        "src-md": tripData.bilder.img1200_16x9,
                        "src-lg": tripData.bilder.img1900_16x9,
                        "aspect-ratio": "16/9",
                        lazyload: false,
                        "img-class": "img-responsive image-pos-mitte",
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            (tripData.overrides && tripData.overrides.content) || tripData.tdbez
              ? _c("div", { staticClass: "slider-promo" }, [
                  _c("div", { staticClass: "container" }, [
                    _c("div", { staticClass: "row" }, [
                      _c(
                        "div",
                        {
                          staticClass:
                            "col-xs-12 col-sm-12 col-md-4 col-md-offset-8",
                        },
                        [
                          (tripData.overrides && tripData.overrides.content) ||
                          tripData.tdbez
                            ? _c(
                                "a",
                                {
                                  staticClass: "slider-promo-link",
                                  attrs: {
                                    href: _vm.url(tripData),
                                    target: _vm.target(tripData),
                                  },
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "promo-inner pull-right" },
                                    [
                                      _c("div", { staticClass: "row" }, [
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-sm-7 col-md-12 promo-description",
                                          },
                                          [
                                            tripData.overrides &&
                                            tripData.overrides.content
                                              ? _c("div", {
                                                  domProps: {
                                                    innerHTML: _vm._s(
                                                      tripData.overrides.content
                                                    ),
                                                  },
                                                })
                                              : _c("div", [
                                                  tripData.laender
                                                    ? _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "country-wrapper",
                                                        },
                                                        [
                                                          _c(
                                                            "p",
                                                            {
                                                              staticClass:
                                                                "country",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.concatCountries(
                                                                    tripData
                                                                  )
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ]
                                                      )
                                                    : _vm._e(),
                                                  _vm._v(" "),
                                                  _c("h4", [
                                                    _vm._v(
                                                      _vm._s(tripData.tdbez)
                                                    ),
                                                  ]),
                                                  _vm._v(" "),
                                                  tripData.abreisedatentext
                                                    ? _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "termine",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              tripData.abreisedatentext
                                                            )
                                                          ),
                                                        ]
                                                      )
                                                    : _c(
                                                        "p",
                                                        {
                                                          staticClass:
                                                            "description",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              tripData.beschreibung
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                ]),
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "div",
                                          {
                                            staticClass:
                                              "col-sm-5 col-md-12 promo-button",
                                          },
                                          [
                                            _c("div", { staticClass: "row" }, [
                                              _c("button", {
                                                staticClass:
                                                  "btn btn-primary btn-arrow",
                                                domProps: {
                                                  innerHTML: _vm._s(
                                                    _vm.button(tripData)
                                                  ),
                                                },
                                              }),
                                            ]),
                                          ]
                                        ),
                                      ]),
                                    ]
                                  ),
                                ]
                              )
                            : _vm._e(),
                        ]
                      ),
                    ]),
                  ]),
                ])
              : _vm._e(),
          ]
        )
      }),
      0
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }